import { render, staticRenderFns } from "./NotificationHeader.vue?vue&type=template&id=7c940117"
import script from "./NotificationHeader.vue?vue&type=script&lang=js"
export * from "./NotificationHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports